// frontend/src/cognitoConfig.ts
export const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID || '', // e.g., "us-east-2_SceevthlP"
    ClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '' // e.g., "6lgtkfkrh3kj8rqtgtijebj8nj"
  };
  